import Swiper from 'swiper/bundle';

var swiperModal;

$(document).ready(function () {
  if($(".front_swiper_ul_li").length === 1 ) {
    $(".front_swiper_ul_li").clone(true).appendTo(".front_swiper_ul");
  };
  window.swiperModal = swiperModal;
  var houseSwiper = new Swiper('.house_swiper', {
    wrapperClass: 'house_swiper_ul',
    slideClass: 'house_swiper_ul_li',
  });
  var frontSwiper = new Swiper('.front_swiper', {
    slidesPerView: "auto",
    loop: true,
    wrapperClass: 'front_swiper_ul',
    slideClass: 'front_swiper_ul_li',
    pagination: {
      el: '.front_swiper_pagenation',
      clickable: true,
    },
    navigation: {
      nextEl: '.front_swiper_next',
      prevEl: '.front_swiper_prev',
    },
  });

  $('.house_thumbnails_ul_li, .house_swiper_ul_li').click(function (){
    $('body').addClass('modal');
    swiperModal = new Swiper('.house_modal_swiper', {
    navigation: {
      nextEl: '.house_modal_button_next',
      prevEl: '.house_modal_button_prev',
    },
      wrapperClass: 'house_modal_swiper_ul',
      slideClass: 'house_modal_swiper_ul_li',
    });
    var index = $(this).index();
    swiperModal.slideTo(index,0);
  });
  $('.house_modal_button').click(function (){
    $('body').removeClass('modal');
    swiperModal.destroy;
  });
  var swiperTop = new Swiper('.house_swiper', {
    wrapperClass: 'house_swiper_ul',
    slideClass: 'house_swiper_ul_li',
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  
});